import React from "react";
import { Switch, Route } from "react-router-dom";
import usePageTracking from "./usePageTracking";

import Home from "./Home";
import {
  Demographics,
  School,
  Coop,
  Lifestyle,
  MentalHealth,
  SexDrugsRelationships,
  PersonalGrowth,
  FuturePlans,
  AdviceConclusions,
  Photos,
} from "./pages";
import Nav from "./Nav";

import "./App.css";

function App() {
  usePageTracking();

  return (
    <div className="App">
      <Nav />
      <div className="Content" id="scroller">
        <Switch>
          <Route path="/demographics">
            <Demographics />
          </Route>
          <Route path="/school">
            <School />
          </Route>
          <Route path="/coop">
            <Coop />
          </Route>
          <Route path="/lifestyle">
            <Lifestyle />
          </Route>
          <Route path="/mental-health">
            <MentalHealth />
          </Route>
          <Route path="/sex-drugs-relationships">
            <SexDrugsRelationships />
          </Route>
          <Route path="/personal-growth">
            <PersonalGrowth />
          </Route>
          <Route path="/future-plans">
            <FuturePlans />
          </Route>
          <Route path="/advice-conclusions">
            <AdviceConclusions />
          </Route>
          <Route path="/photos">
            <Photos />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </div>
    </div>
  );
}

export default App;
